export const removeSideSlashes = (value = '') => value.replace(/^\/|\/$/g, '');
